import CoreMetadata from './CoreMetadata';

export { type CoreMetadataProps } from './CoreMetadata';
export default CoreMetadata;
